import { Typography, IconButton, CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment'
import React, { useEffect, useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { api } from '../../services/api'
import { ArrowBackIosOutlined, ArrowForwardIosOutlined } from '@material-ui/icons'
import useQuery from '../../hooks/useQuery'

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1
	},
	petStatusIcon: {
		position: 'absolute',
		left: 0
	},
	membershipWrapper: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center'
	},
	membershipIcon: {
		color: '#6B4AD6',
		'&::before': {
			fontSize: '14px',
			lineHeight: '14px'
		}
	},
	membershipType: {
		fontFamily: 'Nunito',
		fontSize: '14px',
		fontWeight: 600,
		lineHeight: '19px',
		color: '#777679',
		textTransform: 'capitalize'
	},
	box: {
		padding: 24
		// borderBottomWidth: 1,
		// borderBottomColor: '#D0CFD2',
		// backgroundColor: '#E5E5E5'
	},
	calendarHeader: {
		width: '100%',
		backgroundColor: '#FFFFFF',
		height: 141,
		marginTop: 24,
		padding: 24,
		borderRadius: 10
	},
	calendarHeaderButtons: {
		fill: '#777679'
	},
	calenderHeaderButtonOuter: {
		border: '1px solid #D0CFD2',
		marginLeft: 24,
		marginRight: 24
	},
	calendarRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center'
	},
	week: {
		paddingTop: 24,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-evenly',
		alignItems: 'center'
	},
	weekHeader: {
		// width: '15%',
		// border: '1px solid #D0CFD2',
		flex: 1,
		padding: 8,
		justifyContent: 'center',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	weekRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center'
	},
	dayInt: {
		border: '1px solid #D0CFD2',
		width: '100%',
		borderRadius: 6,
		padding: 12,
		paddingLeft: 16,
		paddingRight: 16,
		height: 140,
		cursor: 'pointer'
	},
	day: {
		flex: 1,
		padding: 5,
		justifyContent: 'center',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	body: {
		marginTop: 24,
		backgroundColor: '#FFFFFF',
		padding: 16,
		borderRadius: 10
	},
	top: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: 6
	},
	percent: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		alignItems: 'center'
	},
	bottom: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
	},
	loading: {
		position: 'absolute',
		top: 0,
		left: 0,
		bottom: 0,
		right: 0,
		opacity: 0.3,
		backgroundColor: 'white',
		justifyContent: 'center',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		paddingLeft: 230
	}
}))

const GroomingCalendar = (props) => {
	const classes = useStyles()

	const facility = useSelector((state) => state.specific.facilities.selected)
	const [loading, setLoading] = useState(false)
	const [month, setMonth] = useState(moment())
	const [days, setDays] = useState({})
	const { getQueryParam, pushQueryParamToHistory, replaceQueryParamInHistory } = useQuery()

	const queryDate = getQueryParam('date')

	useEffect(() => {
		if (queryDate) {
			setMonth(moment(queryDate))
		} else {
			const currentDate = moment()
			setMonth(currentDate)
			replaceQueryParamInHistory({ key: 'date', value: currentDate.format('YYYY-MM') })
		}
	}, [queryDate])

	const handleSetMonth = (date) => {
		setMonth(date)
		if (date && date.format) {
			const newDateParam = date.format('YYYY-MM')
			pushQueryParamToHistory({ key: 'date', value: newDateParam })
		}
	}

	const fetchVisits = useCallback(async () => {
		try {
			if (month && facility) {
				setLoading(true)
				let { data } = await api.get(
					`/grooming/calendar?month=${month.toDate()}&facility_id=${facility._id}`
				)
				setDays(data)
				setLoading(false)
			}
		} catch (e) {
			console.log('err...', e)
			setLoading(false)
		}
	}, [month, facility])

	useEffect(() => {
		fetchVisits()
	}, [fetchVisits])

	return (
		<div className={classes.root}>
			{loading ? (
				<div className={classes.loading}>
					<CircularProgress />
				</div>
			) : null}
			{facility ? (
				<div className={classes.box}>
					<Typography variant="h5" style={{ color: '#270050', fontSize: 22 }}>
						Grooming Calendar
					</Typography>
					<CalendarHeader month={month} setMonth={handleSetMonth} />
					<CalendarBody month={month} days={days} facility_id={facility?._id} />
				</div>
			) : (
				<h3>Please Select a Facility</h3>
			)}
		</div>
	)
}

export default GroomingCalendar

const CalendarHeader = ({ month, setMonth }) => {
	const classes = useStyles()

	const decMonth = () => {
		const newMonth = month.clone().subtract(1, 'month')
		setMonth(newMonth)
	}

	const inccMonth = () => {
		const newMonth = month.clone().add(1, 'month')
		setMonth(newMonth)
	}

	const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

	const getDays = () => {
		let start = month.clone().startOf('month').startOf('week')
		let end = month.clone().endOf('month').endOf('week')

		let dates = []
		for (let i = start; i.isBefore(end); i.add(1, 'day')) {
			dates.push(i.clone())
		}
		return dates
	}

	let daysToRender = getDays()

	const appointments = []

	const selectDay = () => {}

	const today = moment().format('YYYY-MM-DD')

	const onDayPress = () => {}

	return (
		<div className={classes.calendarHeader}>
			<div className={classes.calendarRow}>
				<IconButton className={classes.calenderHeaderButtonOuter} size="small" onClick={decMonth}>
					<ArrowBackIosOutlined className={classes.calendarHeaderButtons} fontSize="small" />
				</IconButton>
				<Typography variant="h6">{month && month.format('MMM YYYY')}</Typography>
				<IconButton className={classes.calenderHeaderButtonOuter} size="small" onClick={inccMonth}>
					<ArrowForwardIosOutlined className={classes.calendarHeaderButtons} fontSize="small" />
				</IconButton>
			</div>
			<div className={classes.week}>
				{days.map((d) => (
					<div className={classes.weekHeader}>
						<Typography variant="h6" style={{ textTransform: 'uppercase' }}>
							{d}
						</Typography>
					</div>
				))}
			</div>
		</div>
	)
}

const CalendarBody = ({ month, days, facility_id }) => {
	const classes = useStyles()
	const history = useHistory()

	const getDays = () => {
		let start = month.clone().startOf('month').startOf('week')
		let end = month.clone().endOf('month').endOf('week')

		let dates = []
		for (let i = start; i.isBefore(end); i.add(1, 'day')) {
			let d = i.clone()
			let dateString = d.format('YYYY-MM-DD')
			dates.push({ day: d, data: days[dateString] || {}, dateString })
		}
		return dates
	}

	let daysToRender = getDays()

	const appointments = []

	const selectDay = () => {}

	const today = moment()

	const onDayPress = (date) => {
		history.push(`/facilities/${facility_id}/groomingAssignment?date=${date}`)
	}

	return (
		<div className={classes.body}>
			<div className={classes.weekRow}>
				{daysToRender.slice(0, 7).map((day) => {
					return (
						<Day
							day={day.day}
							data={day.data}
							appointments={appointments}
							month={month}
							onDayPress={onDayPress}
							today={today}
						/>
					)
				})}
			</div>
			<div className={classes.weekRow}>
				{daysToRender.slice(7, 14).map((day) => {
					return (
						<Day
							day={day.day}
							data={day.data}
							appointments={appointments}
							month={month}
							onDayPress={onDayPress}
							today={today}
						/>
					)
				})}
			</div>
			<div className={classes.weekRow}>
				{daysToRender.slice(14, 21).map((day) => {
					return (
						<Day
							day={day.day}
							data={day.data}
							appointments={appointments}
							month={month}
							onDayPress={onDayPress}
							today={today}
						/>
					)
				})}
			</div>
			<div className={classes.weekRow}>
				{daysToRender.slice(21, 28).map((day) => {
					return (
						<Day
							day={day.day}
							data={day.data}
							appointments={appointments}
							month={month}
							onDayPress={onDayPress}
							today={today}
						/>
					)
				})}
			</div>
			<div className={classes.weekRow}>
				{daysToRender.slice(28, 35).map((day) => {
					return (
						<Day
							day={day.day}
							data={day.data}
							appointments={appointments}
							month={month}
							onDayPress={onDayPress}
							today={today}
						/>
					)
				})}
			</div>
			<div className={classes.weekRow}>
				{daysToRender.slice(35, 42).map((day) => {
					return (
						<Day
							day={day.day}
							data={day.data}
							appointments={appointments}
							month={month}
							onDayPress={onDayPress}
							today={today}
						/>
					)
				})}
			</div>
		</div>
	)
}

const Day = ({ day, data, month, today, onDayPress }) => {
	const classes = useStyles()

	const dayIsInMonth = !!day.isSame(month, 'month')
	const dayIsOver = today.isAfter(day.endOf('day'))
	const isToday = today.isSame(day, 'day')

	const ourStyle = {}
	const textStyle = {
		fontSize: 20,
		fontWeight: '800',
		color: '#1a1a35'
	}

	const percentTextStyle = {
		fontSize: 14,
		fontWeight: '800',
		color: '#5326A5',
		marginRight: 3
	}

	const fullTextStyle = {
		fontSize: 14,
		fontWeight: '600',
		color: '#1A1A35'
	}

	if (data.percent_full > 99) {
		percentTextStyle.color = '#1A1A35'
		fullTextStyle.color = '#1A1A35'
	} else {
		ourStyle.backgroundColor = '#F0EDFB'
	}

	const countStyle = {
		fontSize: 14,
		color: '#5326A5',
		marginRight: 3
	}

	const pendingStyle = {}

	const nameStyle = {
		fontSize: 14,
		fontWeight: '600',
		color: '#1A1A35'
	}

	if (isToday) ourStyle.border = `2px solid #5326A5`
	if (data?.NeedsAction > 0) pendingStyle.color = '#BD1E2C'

	if (dayIsOver) {
		ourStyle.backgroundColor = '#F3F3F3'
		textStyle.color = '#777679'
		percentTextStyle.color = '#777679'
		fullTextStyle.color = '#777679'
		countStyle.color = '#777679'
		nameStyle.color = '#777679'
		pendingStyle.color = '#777679'
	}

	const renderInt = () => {
		if (!dayIsInMonth) return null
		return (
			<>
				<div className={classes.top}>
					<Typography variant="body1" style={textStyle}>
						{day.format('D')}
					</Typography>
					{'percent_full' in data && (
						<div className={classes.percent}>
							<Typography variant="body1" style={percentTextStyle}>
								{data?.percent_full}%
							</Typography>
							<Typography variant="body1" style={fullTextStyle}>
								Full
							</Typography>
						</div>
					)}
				</div>
				<div className={classes.bottom}>
					<Typography variant="body1" style={{ ...countStyle, ...pendingStyle, fontWeight: '800' }}>
						{data?.NeedsAction || 0}
					</Typography>
					<Typography variant="body1" style={{ ...nameStyle, ...pendingStyle }}>
						Needs Action
					</Typography>
				</div>
				<div className={classes.bottom}>
					<Typography variant="body1" style={{ ...countStyle, fontWeight: '800' }}>
						{data?.Approved || 0}
					</Typography>
					<Typography variant="body1" style={nameStyle}>
						Approved
					</Typography>
				</div>
				<div className={classes.bottom}>
					<Typography variant="body1" style={{ ...countStyle, fontWeight: '800' }}>
						{data?.InProgress || 0}
					</Typography>
					<Typography variant="body1" style={nameStyle}>
						In Progress
					</Typography>
				</div>
				<div className={classes.bottom}>
					<Typography variant="body1" style={{ ...countStyle, fontWeight: '800' }}>
						{data?.Completed || 0}
					</Typography>
					<Typography variant="body1" style={nameStyle}>
						Completed
					</Typography>
				</div>
			</>
		)
	}

	return (
		<div className={classes.day}>
			<div className={classes.dayInt} style={ourStyle} onClick={() => onDayPress(day.format('YYYY-MM-DD'))}>
				{renderInt()}
			</div>
		</div>
	)
}
